import { render, staticRenderFns } from "./termsAndCondModal.vue?vue&type=template&id=c9a5b4e2&"
import script from "./termsAndCondModal.vue?vue&type=script&lang=js&"
export * from "./termsAndCondModal.vue?vue&type=script&lang=js&"
import style0 from "./termsAndCondModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "termsAndCondModal.vue"
export default component.exports